import { render, staticRenderFns } from "./DashboardCustomerHistoryOrder.vue?vue&type=template&id=1a0cc6f8&"
import script from "./DashboardCustomerHistoryOrder.vue?vue&type=script&lang=js&"
export * from "./DashboardCustomerHistoryOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports